import * as React from 'react';
import classnames from 'classnames';

const ResponsiveImage = ({ src , srcSet , alt , className , sizes , 'data-t': dataT , isContained ,  })=>/*#__PURE__*/ React.createElement("img", {
        "data-t": dataT || 'responsive-image',
        width: "100%",
        className: classnames('responsive-image', className, {
            'responsive-image--is-contained': isContained
        }),
        src: src,
        srcSet: srcSet,
        sizes: sizes,
        alt: alt
    })
;

export { ResponsiveImage as default };
//# sourceMappingURL=ResponsiveImage.js.map
